import { RouteConfig } from "QuorumGrassroots/framework/helpers/RouteRegistry"
import { keyDatesRoutes } from "QuorumGrassroots/pages/campaign/key-dates/routes"
import { voterInformationRoutes } from "QuorumGrassroots/pages/campaign/voter-information/routes"

export const campaignRoutes: RouteConfig[] = [...keyDatesRoutes, ...voterInformationRoutes]
